import Vue from 'vue'

import VueIntercom from 'vue-intercom';
Vue.use(VueIntercom, { appId: 'zetpu2p7' });
let thisVue = new Vue()

const state = {
    messages: [],
    isTryingLogin: false,
    accountSetup: [],
    defaultRedirect: 'dashboard',
    account: {
        name: '',
        email: '',
        supplierId: null,
        agentId: null,
    },
    accessTypes: [
        {
            id:0,
            label: 'Basic',
            code: 'basic'
        },
        {
            id:1,
            label: 'Admin',
            code: 'admin'
        },
        {
            id:2,
            label: 'Restricted',
            code: 'restricted'
        },
        {
            id:3,
            label: 'Main Supervisor',
            code: 'mainSupervisor',
            group: 'supervisor'
        },
        {
            id:4,
            label: 'Agent Supervisor',
            code: 'agentSupervisor',
            group: 'supervisor'
        },
        {
            id:5,
            label: 'Marketing Supervisor',
            code: 'marketingSupervisor',
            group: 'supervisor'
        },
        {
            id:6,
            label: 'My Team Supervisor',
            code: 'myTeamSupervisor',
            group: 'supervisor'
        },
        {
            id:7,
            label: 'Viewer',
            code: 'viewer'
        },
    ]
}

const getters = {
    getIsTryingLogin: state => state.isTryingLogin,
    accountSetup: state => state.accountSetup,
    getMessages: state => state.messages,
    account: state => state.account,
    getActiveIntegrations: state => {
        if(!state.account.supplier){
            return {}
        }

        return {
            getYourGuide: state.account.supplier.hasGYGIntegration? state.account.supplier.hasGYGIntegration : false
        }
    },
    getUserAccessTypes: state => state.accessTypes,
    getUserAccessType: (state) => {
        //given the acceessId return the accessObject
        function getAccessObject(accessId){
            return state.accessTypes.filter(accessType => {
                return accessType.id == accessId
            })[0]
        }
        // ------------------------------------------

        if(state.account.accessType == undefined){
            return getAccessObject(2) // Baseic user id = 2
        } else {
            //the current user has an accessType now we check if it a valid one
            let testArr = state.accessTypes.filter(accessType => {
                return accessType.id == state.account.accessType
            })


            if(testArr.length > 0){
                return getAccessObject(state.account.accessType)
            } else {
                //if the accessType is not valid returns basic access id
                return getAccessObject(2)
            }
        }
    }
};

const actions = {
    // Logs a user in both from the API and the client

    login: ({ state, commit, dispatch }, data) => {
        let params = data.params;
        let query = data.query;

        state.isTryingLogin = true

        axios.post(axios.authURL + 'auth/login', params).then((response) => {
            state.isTryingLogin = false
            if (response && response.status === 200 && response.data.access_token) {
                localStorage.setItem('pluralo_token', response.data.access_token);

                //show loading screen
                dispatch('switchLayout', 'Loading')

                dispatch('checkUser').then(r => {

                    if(r != 'agent'){
                        // redirects to the correct view, hiding the loading screen
                        Vue.router.push({ name: query.redirect ? query.redirect : state.defaultRedirect });
                    }

                    if(r == 'revokedByApi'){
                        // redirects to the correct view, hiding the loading screen
                        console.log('revokedByApi response');
                        Vue.router.push({ name: 'auth.login'});
                    }

                })


            }
        })
        .catch((error) => {
            state.isTryingLogin = false
            Vue.toasted.error(error.response.data.error_description, { className: 'auth-alert' });
        });
    },

    // Logs a user out both from the API and the client

    logout: ({ commit, dispatch }) => {
        axios.get(axios.authURL + 'auth/logout').then((response) => {
            if (response && response.status === 200) {
                // mixpanel
                thisVue.$ma.trackEvent({action:'Logout'})
                dispatch('clearAllNotifications')
                dispatch('clientLogout');
                commit('CLEAR_CHECK_NOTIFICATIONS_INTERVAL');
            }
        })
        .catch(function (error) {
            console.log(error);
            Vue.toasted.error(error.response.data.message, { className: 'auth-alert' });
        });
    },

    // Logs a user out - client-side only (no API check)

    clientLogout: ({ state, commit, dispatch }) => {
        localStorage.removeItem('pluralo_token');
        thisVue.$intercom.shutdown();
        thisVue.$intercom.boot();

        dispatch('closeModal');

        // commit('UPDATE_ACCOUNT', {
        //     name: '',
        //     email: '',
        //     supplierId: null,
        //     agentId: null,
        //     id: null,
        // });

        commit('CLEAR_ACCOUNT')

        // mixpanel
        thisVue.$ma.reset()

        Vue.router.push({ name: 'auth.login' });
    },

    // Registers an agent

    register: ({ commit }, fields) => {
        return axios.post(axios.authURL + 'auth/registerAgent', fields).then((response) => {
            if (response && response.status === 200) {
                Vue.router.push({ name: 'auth.login', params:{validateAccount: true}});
                // Vue.toasted.success(response.data.message, { className: 'auth-alert' });
            }
            return response
        })
        .catch(function (error) {
            //Vue.toasted.error(error.response.data.message, { className: 'auth-alert' });
            return error
        });
    },

    // Registers a supplier

    registerSupplier: ({ commit }, fields) => {
        return axios.post(axios.authURL + 'auth/registerSupplier', fields.parsed).then((response) => {
            if (response && response.status === 200) {

                //mixpanel
                // thisVue.$ma.setUserProperties({
                //     userId: XXXX, //adicionar id que virá na response
                //     email: fields.json.email,
                //     name: fields.json.name
                // })

                Vue.router.push({ name: 'auth.login', params:{validateAccount: true} });
                Vue.toasted.success(response.data.message, { className: 'auth-alert' });
            }
            return response
        })
        .catch(function (error) {
            Vue.toasted.error(error.response.data.message, { className: 'auth-alert' });
            return error
        });
    },

    // Gets all messages and notifications for the current user

    fetchMessages: ({ commit }) => {
        var messages = [
            {
                id: 1,
                title: 'Request for information',
                intro: 'Do you have 10PAX availability for Cruise tomorrow 10:00?',
                description: 'Big group wants to go for a cruise tommorrow.',
                user: 'Anne Smith',
                isRead: false
            },
            {
                id: 2,
                title: 'PROMO10 not working',
                intro: 'Trying to insert promo10 but not working',
                description: 'Hi there, not sure what happen, is promo10 still available?',
                user: 'John Marshall',
                isRead: true
            },
        ];

        commit('GET_MESSAGES', messages);
    },




    // Takes a new message object and adds it to the list

    addMessage: ({ commit }, message) => {
        commit('ADD_NEW_MESSAGE', message);
    },

    // Sets up the account form fields in a common object

    updateAccountSetup: ({ commit, state }, fields) => {
        commit('UPDATE_FIELDS', { object: 'accountSetup', fields: fields });
    },

    // Resets the account setup object for agents and suppliers

    resetAccountSetup: ({ commit, dispatch }, type) => {
        let reset = {};

        if (type === 'agent') {
            reset = {
                email: '',
                password: '',
                name: '',
                // size: null,
                // salesStore: false,
                // salesWebsite: false,
                // salesHotel: false,
                companyName: '',
                imageLogoBase64: null,
                // salesChannel: null,
                // country: null,
                // timezone: null,
                // currency: null,
                step: null,
                type: type,
            };
        }
        else {
            reset = {
                email: '',
                password: '',
                country: null,
                timezone: null,
                currency: null,
                step: null,
                type: type,
            };
        }

        commit('RESET_ACCOUNT_SETUP', reset);
        dispatch('clearAllNotifications')
    },

    async checkUser ({state, commit, dispatch}, payload){
        // Checks if the user is supplier -> logged in or not
        // checks if is an agent
        // possible outputs:
        //  notLogged
        //  inactive
        //  supplier
        //  agent


        // download common stuff
        // downloads
        let downloads = async () => {

        }

        downloads()

        if (localStorage.getItem('pluralo_token')){
            // user loggedin

            // get details to know what kind of user (supplier or agent)

            return axios.get('api/user/GetUserDetails').then(response => {
                console.log('api/user/GetUserDetails', response);

                if(response.data){

                    // User is Agent
                    if(response.data.userAccountTypeDefault.accountType == 1){
                        dispatch('agentAccess', payload)
                        return 'agent'
                    }

                    if(response.data.isActive == false){
                        dispatch('inactiveUserAccess')
                        return 'inactive'
                    }

                    // User is Supplier
                    if(response.data.userAccountTypeDefault.accountType == 2){
                        dispatch('supplierAccess', response)
                        return 'supplier'
                    }

                } else {

                    // if API says that user cannot stay logged in
                    if(response.serverInfo.isToShowServerInfo == true){
                        // Vue.router.push({name: 'auth.login'})
                        localStorage.clear()
                        console.log('revokedByApi');
                        return 'revokedByApi'
                    }

                }






            }).catch(err => {
                // localStorage.clear()
                // Vue.toasted.error('Something went wrong, please try again');
                // Vue.router.push({name: 'auth.login'})
            })
        } else {
            // user not loggedin
            return 'notLogged'
        }
    },

    inactiveUserAccess ({state, commit, dispatch}) {
        localStorage.clear()
        Vue.toasted.error('Account inactive');
        Vue.router.push({name: 'auth.login'})
    },

    supplierAccess ({state, commit, dispatch}, payload) {
        // request user to allow browser notifications // disabled for now, we will only use inside notifications
        // Notification.requestPermission();

        // mixpanel
        thisVue.$ma.setUserPropertiesOnce({
            userId: payload.data.id,
            email: payload.data.email,
            name: payload.data.name,
            accessType: payload.data.userAccountTypeDefault.accessType,
            accountType: payload.data.userAccountTypeDefault.accountType,
            supplierId: payload.data.userAccountTypeDefault.supplierId,
            supplierName: payload.data.userAccountTypeDefault.supplier.brand,
            // supplier: payload.data.userAccountTypeDefault.supplier,
            // agentId: payload.data.userAccountTypeDefault.agentId,
            // agent: payload.data.userAccountTypeDefault.agent,
            // avatar: payload.data.imagePhoto,
            // salesChannel: payload.data.salesChannel
        })
        thisVue.$ma.identify({
            userId: payload.data.id,
        })

        thisVue.$ma.trackEvent({action:'Login'})

        const data = {
            id: payload.data.id,
            email: payload.data.email,
            name: payload.data.name,
            accessType: payload.data.userAccountTypeDefault.accessType,
            accountType: payload.data.userAccountTypeDefault.accountType,
            supplierId: payload.data.userAccountTypeDefault.supplierId,
            agentId: payload.data.userAccountTypeDefault.agentId,
            supplier: payload.data.userAccountTypeDefault.supplier,
            agent: payload.data.userAccountTypeDefault.agent,
            avatar: payload.data.imagePhoto,
            salesChannel: payload.data.salesChannel
        };


        commit('UPDATE_ACCOUNT', data);

        // downloads
        let downloads = async () => {
            await dispatch('downloadEventColors')
            await dispatch('downloadAudienceTypeList')
            await dispatch('initExtras')
            await dispatch('initCategories')
            await dispatch('initProducts')
            await dispatch('downloadSalesChannels')
            await dispatch('downloadSlimFilters')
            await dispatch('downloadRoutes')
            await dispatch('downloadAgents')
            await dispatch('downloadTeam')
            await dispatch('initSettings')
            // await dispatch('fetchNotifications')
        }

        downloads().then(r => {

            return 'supplier'

        })
    },

    agentAccess ({state, commit, dispatch}, payload) {
        if(payload && payload.route && payload.route.path == "/logout"){
            dispatch('logout')
        } else {
            window.location.href = process.env.AGENT_PORTAL_URL + "/?token=" + localStorage.getItem('pluralo_token');

        }
    },

    // Tests if the user is logged in or not by retrieving his token
    refreshAccountData ({ state, commit, dispatch }, routeName) {
        return axios.get('api/user/GetUserDetails').then(user => {
            // Checks if user account is active, if its not redirects to login
            if(user.data.isActive == false){
                localStorage.clear()
                Vue.toasted.error('Account inactive');
                Vue.router.push({name: 'auth.login'})
            }

            if(user.data.userAccountTypeDefault.accountType == 1){

                //is an agent that just logged in and not requesting a logout
                window.location.href = process.env.AGENT_PORTAL_URL + "/?token=" + localStorage.getItem('pluralo_token');
                return user
            }


            const data = {
                id: user.data.id,
                email: user.data.email,
                name: user.data.name,
                accessType: user.data.userAccountTypeDefault.accessType,
                accountType: user.data.userAccountTypeDefault.accountType,
                supplierId: user.data.userAccountTypeDefault.supplierId,
                agentId: user.data.userAccountTypeDefault.agentId,
                supplier: user.data.userAccountTypeDefault.supplier,
                agent: user.data.userAccountTypeDefault.agent,
                avatar: user.data.imagePhoto,
                salesChannel: user.data.salesChannel,
            };


            commit('UPDATE_ACCOUNT', data);
            dispatch('downloadSlimFilters')
            return user
        }).catch(error => {
            console.log(error);
            return error
        })
    },
}

const mutations = {
    UPDATE_ACCOUNT: (state, fields) => {
        Object.keys(fields).forEach((key) => {
            Vue.set(state.account, key, fields[key]);
        });
    },

    CLEAR_ACCOUNT: (state) => {
        state.account = {}
    },

    GET_MESSAGES: (state, messages) => {
        state.messages = messages;
    },


    ADD_NEW_MESSAGE: (state, message) => {
        state.messages.push(message);
    },

    UPDATE_FIELDS: (state, data) => {
        if (state[data.object] === undefined || !state[data.object]) {
            state[data.object] = {};
        }

        Object.keys(data.fields).forEach((key) => {
            Vue.set(state[data.object], key, data.fields[key]);
        });
    },

    RESET_ACCOUNT_SETUP: (state, fields) => {
        state.accountSetup = fields;
    },


}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js